export default function Toast({ message, type }) {
  return (
    <div className={`toast${type && type !== "default" ? ` ${type}` : ""}`}>
      {type === "success" && "✓ "}
      {type === "error"   && "✕ "}
      {message}
    </div>
  );
}
